<!-- Outer page: white background -->
<div class="hp-outer-page">
  <div class="hp-phone-frame">
    <main class="hp-main" role="main">

      <!-- Card header: spacer + centered title + spacer -->
      <div class="hp-input-area">
        <div class="hp-card-header">
          <div class="hp-spacer">
            <button class="hp-back-btn" type="button" (click)="navigate('login')" aria-label="ログインに戻る">
              <img src="assets/healthpicks/images/back-arrow.svg" alt="戻る" />
            </button>
          </div>
          <h2 class="hp-nav-title">パスワードの再設定</h2>
          <div class="hp-spacer"></div>
        </div>

        <!-- Description -->
        <p class="hp-nav-description">
          下記に登録したメールアドレスを入力してください。<br>
          パスワード再設定のご案内をメールでお送りします。
        </p>

        <form class="hp-login-form" (ngSubmit)="changePassword()" novalidate>
          <div class="hp-fields">
            <div class="hp-field-group" [class.hp-field-group--error]="errorMessages.forgetpassword.email">
              <label class="hp-field-group__label" for="fp-email">メールアドレス</label>
              <div class="hp-field-group__input-wrap">
                <input
                  type="email"
                  id="fp-email"
                  [(ngModel)]="email"
                  name="email"
                  placeholder="メールアドレス"
                  autocomplete="email"
                  class="hp-field-group__input"
                />
              </div>
              <app-healthpicks-field-error [message]="errorMessages.forgetpassword.email"></app-healthpicks-field-error>
            </div>
          </div>
          <div class="hp-actions">
            <button
              type="submit"
              class="hp-btn-login"
              [disabled]="!email"
            >
              送信
            </button>
          </div>
        </form>
      </div>
    </main>
  </div>
</div>
